import type {} from "@lit/react";
import { AvatarGroup as AvatarGroupElement, } from "@vaadin/avatar-group/vaadin-avatar-group.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { AvatarGroupElement, };
export type AvatarGroupEventMap = Readonly<{}>;
const events = {} as AvatarGroupEventMap;
export type AvatarGroupProps = WebComponentProps<AvatarGroupElement, AvatarGroupEventMap>;
export const AvatarGroup = createComponent({
    elementClass: AvatarGroupElement, events, react: React, tagName: "vaadin-avatar-group"
});
